export type SubjectRequestMessages = {
  deleteSubjectSuccess: string;
  createSubjectSuccess: string;
  updateSubjectSuccess: string;

  deleteSubjectError: string;
  createSubjectError: string;
  updateSubjectError: string;
  subjectNotFoundError: string;
  subjectNotFoundDescription: string;
  subjectNotFoundAlt: string;
  subjectErrorToLoad: string;
};

export const SUBJECT_REQUEST_MESSAGES: SubjectRequestMessages = {
  deleteSubjectSuccess: "Assunto deletado com sucesso.",
  createSubjectSuccess: "Assunto criado com sucesso.",
  updateSubjectSuccess: "Assunto editado com sucesso.",

  deleteSubjectError: "Erro ao deletar assunto.",
  createSubjectError: "Erro ao criar assunto.",
  updateSubjectError: "Erro ao editar assunto.",
  subjectNotFoundError: "Assuntos não encontrados.",
  subjectNotFoundDescription:
    "Não conseguimos encontrar nenhum assunto, recarregue a página e tente novamente.",
  subjectNotFoundAlt: "Imagem indicando erro ao buscar assuntos.",
  subjectErrorToLoad: "Erro ao buscar assuntos.",
};
